import { render, staticRenderFns } from "./DatosEditar.vue?vue&type=template&id=2bdb0ffa"
import script from "./DatosEditar.vue?vue&type=script&lang=js"
export * from "./DatosEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports